enum Sections {
  coverDetails = 'coverDetails',
  makingAClaim = 'makingAClaim',
  switching = 'switching',
}

enum Topics {
  boilerCoverVsHomeInsurance = 'boilerCoverVsHomeInsurance',
  homeEmergency = 'homeEmergency',
  annualBoilerService = 'annualBoilerService',
  boilerWarranty = 'boilerWarranty',
  oldBoiler = 'oldBoiler',
  existingProblem = 'existingProblem',
  rentingToTenants = 'rentingToTenants',
  coverageDuration = 'coverageDuration',
  cancelCurrentBoilerCover = 'cancelCurrentBoilerCover',
  coverStartTime = 'coverStartTime',
  howToClaim = 'howToClaim',
  bookingBoilerService = 'bookingBoilerService',
  excessFee = 'excessFee',
}

export { Topics, Sections };
